<!--  -->
<template>
  <div class="main_w">
    <img src="~@/assets/images/ad/ad2/22.png" alt="" class="shou" />
    <div class="v3">活动时间：7月5日-8月4日</div>
    <div class="v1">
      <div
        v-for="(item, index) in provinceList"
        :key="index"
        :class="['v1_1', { active: province.includes(item) }]"
        @click="onPrivinceChange(item)"
      >
        {{ item }}
      </div>
    </div>
    <div
      v-for="(item, index) in ticketList"
      :key="index"
      class="v2"
      @click="onTapItem"
    >
      <div class="v2_1 flex_row">
        <img
          :src="getServiceTypeIcon({ serviceType: item.serviceType, type: 2 })"
          alt=""
          class="v2_1_img"
        />
        <span class="v2_1_t1">{{ item.serviceType }}</span>
        <div class="flex_space"></div>
        <span class="v2_1_t2">¥{{ item.totalprice }}</span>
      </div>
      <div class="v2_2">
        <div class="v2_2_1">{{ item.serviceCategory }}</div>
        <div class="v2_2_2">{{ item.serviceContent }}</div>
      </div>
      <div class="v2_3 flex_row">
        <span class="v2_3_t1">{{ item.serviceDate }}</span>
        <div class="flex_space"></div>
        <img src="~@/assets/images/ticket/icon23.png" alt="" class="v2_3_img" />
        <span class="v2_3_t2">{{ item.serviceLocation }}</span>
      </div>
    </div>
    <div class="v4" @click="onTapItem">注册神州邦邦 查看全部订单</div>
    <div class="v7">
      <div class="v7_1">活动规则</div>
      <p class="v7_2">1.本次活动仅面向通过本页面注册的新用户。</p>
      <p class="v7_2">
        2.用户完成注册后3个自然日（包含注册当日）报名接单即获得该订单现结资格，中标并按平台要求完成实施，验收合格后，可对该笔订单操作现结。
      </p>
      <p class="v7_2">
        3.现结订单权益仅限不大于1000元的订单，否则该笔订单无法享受现结权益。
      </p>
      <p class="v7_2">
        4.如工程师报名多笔订单，仅限首笔满足注册后3个自然日内报名（如：6月9日完成注册，6月11日24时之前报名的订单有效）、符合平台验收要求且金额不大于1000元的订单享受现结权益。
      </p>
      <p class="v7_2">
        5.现结权益使用：订单验收合格后一个工作日内，账户中可收到1张现结券，用户对该笔订单申请提现时，勾选现结券后提交，即可享受现结权益，现结券仅限该笔订单使用。
      </p>
      <p class="v7_2">6.如有本活动其他相关问题，请咨询：400-676-3988。</p>
    </div>
  </div>
</template>

<script>
import {
  checkLogin,
  openLoginPop,
  initShare,
  getServiceTypeIcon,
} from "@/utils/index";
import { get } from "@/utils/request";
import { api, h5 } from "@/utils/env";
import { Toast } from "vant";
import ticket from "./ticket.json";
import moment from "moment";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      initShareObg: null,
      provinceList: [
        "北京",
        "上海",
        "山东",
        "广东",
        "江苏",
        "天津",
        "河南",
        "河北",
        "四川",
        "浙江",
        "辽宁",
        "陕西",
        "安徽",
        "湖北",
        "其他",
      ],
      province: "北京",
      ticketList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getServiceTypeIcon,
    onTapItem() {
      checkLogin({
        success: () => {
          this.$router.push({
            name: "20220602RegSuccess",
          });
        },
        fail: () => {
          openLoginPop({
            reg_source: "act20220608",
            title: "马上注册接单",
            cantReload: true,
            loginSuccess: () => {
              this.$router.push({
                name: "20220602RegSuccess",
              });
            },
          });
        },
      });
    },
    onPrivinceChange(val) {
      this.province = val;
      this.getTicketList();
    },
    getTicketList() {
      get({
        url: api + "bangActivity/orderInfoList",
        data: {
          serviceLocation: this.province,
        },
        requestType: 3,
      })
        .then((data) => {
          if (data.result === "success") {
            let ticketList = data.body || [];
            const province = JSON.parse(JSON.stringify(ticket)).find(
              (item) => item.province === this.province
            );
            if (province) {
              const _ticketList = province.ticket;
              ticketList = ticketList.concat(_ticketList.splice(0, 6));
            }
            // if (ticketList.length < 6) {
            //   const province = JSON.parse(JSON.stringify(ticket)).find(
            //     (item) => item.province === this.province
            //   );
            //   if (province) {
            //     const _ticketList = province.ticket;
            //     ticketList = ticketList.concat(
            //       _ticketList.splice(0, 6 - ticketList.length)
            //     );
            //   }
            // }
            this.ticketList = ticketList.map((item) => {
              item.serviceDate = moment(item.serviceDate).format("YYYY-MM-DD");
              return item;
            });
          } else {
            Toast(data.message);
          }
        })
        .catch(() => {});
    },
    onDownload() {
      // location.href = `${h5}app/callApp.html`;
      location.href = `${h5}app/install.html?source=ENGINEER&navFrom=act20220325`;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initShareObg = new initShare({
      shareUrl: `${h5}app/v2/active/active-20220602/index.html`,
      sharePath: "commonh5",
      imgUrl: require("@/assets/images/Output84.png"),
      miniAppImgUrl:
        "https://static.shenzhoubb.com/images/ad/popup/popup20220328.png",
      title: "大批订单等您报名ing，接单享现结～",
      desc: "IT信息服务订单覆盖全国，报名接单还有机会享现结权益，申请提现3日内到账。",
      shareBtCb: () => {},
    });
    get({
      url: api + "api/common/getAddressByIp",
      data: {},
      requestType: 3,
    })
      .then((data) => {
        if (data.result === "success") {
          this.province = data.body.province;
        } else {
          Toast(data.message);
        }
        this.getTicketList();
      })
      .catch(() => {
        this.getTicketList();
      });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.main_w {
  width: 7.5rem;
  min-height: 100vh;
  margin: 0 auto;
  background: #ff8852;
  background-image: url(~@/assets/images/ad/ad2/21.png);
  background-repeat: no-repeat;
  background-size: 7.5rem auto;
  overflow: hidden;
  position: relative;
  padding-bottom: 1rem;
  .shou {
    position: absolute;
    width: 0.56rem;
    height: 0.64rem;
    left: 1.3rem;
    top: 5.18rem;
    animation: dian 0.5s linear infinite;
  }
}
.v1 {
  width: 5.8rem;
  margin: 0.72rem auto 1.74rem;
  display: grid;
  grid-template-columns: repeat(5, 1rem);
  grid-gap: 0.17rem 0.15rem;
  .v1_1 {
    height: 0.48rem;
    line-height: 0.48rem;
    background: linear-gradient(180deg, #ffffff 0%, #ffd8d8 47%, #ff7878 100%);
    box-shadow: 0.05rem 0.05rem 0px 0px #e60000;
    border-radius: 0.04rem;
    text-align: center;
    font-size: 0.25rem;
    color: #9d1500;
  }
  .active {
    background: linear-gradient(180deg, #fffedb 0%, #ffca00 100%);
    box-shadow: 0.05rem 0.05rem 0px 0px #e60000;
    color: #fb4529;
  }
}
.v2 {
  width: 6.78rem;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 0.16rem;
  box-shadow: 0.1rem 0.13rem 0px 0px #ffa4a4;
  padding: 0 0.25rem;
  margin: 0 0.42rem 0.3rem 0.3rem;
  .v2_1 {
    align-items: center;
    height: 0.8rem;
    .v2_1_img {
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.1rem;
    }
    .v2_1_t1 {
      font-size: 0.26rem;
      font-weight: bolder;
      color: #353232;
    }
    .v2_1_t2 {
      font-size: 0.26rem;
      font-weight: bolder;
      color: #fb4529;
    }
  }
  .v2_2 {
    background: #f9f9f9;
    border-radius: 0.08rem;
    box-sizing: border-box;
    padding: 0.1rem 0.2rem;
    .v2_2_1 {
      font-size: 0.22rem;
      color: #595353;
      margin-bottom: 0.15rem;
    }
    .v2_2_2 {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      line-height: 0.31rem;
      font-size: 0.2rem;
      color: #948e8e;
      height: 0.62rem;
    }
  }
  .v2_3 {
    align-items: center;
    height: 0.54rem;
    .v2_3_t1 {
      font-size: 0.22rem;
      color: #595353;
    }
    .v2_3_t2 {
      font-size: 0.22rem;
      color: #595353;
    }
    .v2_3_img {
      width: 0.2rem;
      height: 0.26rem;
      margin-right: 0.1rem;
    }
  }
}
.v3 {
  font-size: 0.2rem;
  color: #ffffff;
  text-align: center;
  margin-top: 1.6rem;
}
@keyframes dian {
  0% {
    transform: translateY(0.12rem);
  }
  50% {
    transform: translateY(0rem);
  }
  100% {
    transform: translateY(0.12rem);
  }
}
.v4 {
  width: 6.32rem;
  height: 0.83rem;
  line-height: 0.83rem;
  background: linear-gradient(180deg, #fffedb 0%, #ffca00 100%);
  box-shadow: 0.05rem 0.05rem 0px 0px #e60000;
  border-radius: 0.16rem;
  text-align: center;
  color: #fb4529;
  font-size: 0.34rem;
  margin: 0 auto 0.23rem;
}
.v7 {
  width: 6.9rem;
  background: #ffffff;
  border-radius: 0.16rem;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 0.4rem;
  box-sizing: border-box;
  padding: 0 0.4rem 0.4rem;
  .v7_1 {
    width: 1rem;
    font-size: 0.24rem;
    font-weight: bolder;
    color: #595353;
    margin: 0.2rem auto;
    position: relative;
    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      left: -0.6rem;
      height: 0.01rem;
      width: 0.4rem;
      background: #d8d8d8;
    }
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      right: -0.6rem;
      height: 0.01rem;
      width: 0.4rem;
      background: #d8d8d8;
    }
  }
  .v7_2 {
    font-size: 0.22rem;
    color: #948e8e;
    line-height: 0.32rem;
  }
}
</style>